var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBicepsBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2_00000120517201967323416790000011313275019703415194_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 514.6 509.7",
    style: {
      enableBackground: "new 0 0 514.6 509.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0D6EFD;stroke:#0D6EFD;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M212.7,32.9c0,0-2.5,63.2-0.6,76.8s16.8,42.4,53.5,38.9l83.1,0.8c0,0,11.8,0.1,12.2,14.5s0.5,119,0.5,119 s-37.2-20.5-132.5-5.1c0,0-119.2-108.5-215.5,36.7c0,0-65.4,145.4,99,194.5c0,0,179,7,312.7-54.8s77.3-36,77.3-36 c4.3-2.2,7.6-6.1,9.2-10.8c0,0,1.9-134-8.2-169.6s-16.8-119-73.4-213.1c0,0-9.5-25.7-40.8-23.7S255.6,1,255.6,1 S229.2-5.9,212.7,32.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBicepsBlue);
export default __webpack_public_path__ + "static/media/biceps-blue.a0bea925821f717aa31aab9a6c17454d.svg";
export { ForwardRef as ReactComponent };